export default "__VITE_ASSET__0949f1ac__"